import { Mutation, Action } from 'vuex-module-decorators'

export class TextWithSize {
    text: string
    size: number

    constructor(text: string, size: number) {
        this.text = text
        this.size = size
    }

    @Mutation
    public SET_TEXT(text: string) {
        this.text = text
    }

    @Mutation
    public SET_SIZE(size: number) {
        this.size = size
    }

    @Action({ commit: 'SET_TEXT' })
    public SetText(text: string) {
        return text
    }

    @Action({ commit: 'SET_SIZE' })
    public SetSize(size: string) {
        return size
    }
    
}